<template>
  <el-table-column
    v-bind="$attrs"
    :label="label"
    :header-align="$attrs['header-align'] || $attrs.align || 'center'"
    :align="$attrs.align || 'center'"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row[idField] === null"
      >
        {{ $t('api.prodtag_uniqtag.default') }}
      </div>
      <div v-else>
        <item-link
          v-if="showGroup && scope.row[groupIDField]"
          base="prodtag_group"
          basePath="/region/tag/prodtag_group"
          :idField="groupIDField"
          :nameField="groupNameField"
          :rowData="scope.row"
          type="info"
        >
        </item-link>
        <span
          v-if="showGroup && showTag"
        >
          -
        </span>
        <item-link
          v-if="showTag && scope.row[idField]"
          base="prodtag"
          basePath="/region/tag/prodtag"
          :idField="idField"
          :nameField="nameField"
          :rowData="scope.row"
          type="primary"
        >
        </item-link>
      </div>
    </template>
  </el-table-column>
</template>

<script>

import { getLabelText } from '@/utils/i18n'

export default {
  name: 'tag-field',
  props: {
    base: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    showGroup: {
      type: Boolean,
      default: true
    },
    showTag: {
      type: Boolean,
      default: true
    },
    idField: {
      type: String,
      default: 'id'
    },
    nameField: {
      type: String,
      default: 'name'
    },
    groupIDField: {
      type: String,
      default: 'group_id'
    },
    groupNameField: {
      type: String,
      default: 'group_name'
    },
    labelText: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
    label () {
      if (this.labelText !== null) {
        return this.labelText
      }
      return this.getLabelText(this.base, this.name)
    }
  },
  methods: {
    getLabelText
  },
  watch: {
  }
}
</script>
